<template>
    <div>
      <div :style="'z-index: 0;position: relative;height:160px;color#fff;padding:15px;background-image: linear-gradient(0deg,' + $bgColor + '0%,' + $bgColor2 + '100%);'">
        <div :style="'height: 143px;background-color:' + $bgColor2 + ';width: 143px;border-radius: 100px;position: absolute;z-index: -1;right: 14px;top: -52px;'"></div>
        <div :style="'height: 90px;background-color:' + $bgColor2 + ';width: 45px;border-top-left-radius: 110px;border-bottom-left-radius: 110px;position: absolute;z-index: -1;right: 1px;top: 29px;'"></div>
        <div :style="'height: 89px;background-color:' + $bgColor3 + ';width: 89px;border-radius: 100px;position: absolute;z-index: -1;right: 17px;top: 58px;'"></div>
        <v-row>
          <strong style="color:#fff;font-size: 20px;padding:15px;">{{ $t("message.myCredis") }}</strong>
          <div style="align-items: center;display: flex;"></div>
        </v-row>
          <v-row justify="center" class="mt-3 pt-2">
            <v-col cols="5" align="center" class="pa-2" style="font-size:15px;background-color:#ffff;box-shadow: 0px 1px 1px 0px #00000040;border-radius: 15px;">
              {{ $t("message.currentCredits") }}
            <v-col align="center" class="pa-0" :style="'font-weight: bold;font-size:20px;color:' + $bgColor">{{formatNumber(creditData.current_credits)}}<img
                  style="
                    border-color: white;
                    height: 25px;
                    margin-top: 5px;
                    margin-left: 10px;
                  "
                  alt="Avatar"
                  :src="require('@/assets/money.png')"
                  /></v-col>
            </v-col>
            <!-- <v-col cols="4" align="center" class="pa-2" style="font-size:15px;background-color:#ffff;box-shadow: 0px 1px 1px 0px #00000040;border-top-right-radius: 15px;border-bottom-right-radius: 15px;">
              {{ $t("message.totalCredits") }}
              <v-col align="center" :style="'font-weight: bold;font-size:20px;color:' + $bgColor" class="pa-0">{{creditData.total_credits}}</v-col>
            </v-col> -->
          </v-row>
      </div>
      <div>
        <template style="padding-top:10px">
        <v-tabs v-model="tab" dark :background-color='$bgColor2'>
          <v-tabs-slider :color="$bgColor"></v-tabs-slider>
          <v-tab href="#tab-1"> {{ $t("message.historyCredits") }} </v-tab>

        </v-tabs>

        <v-tabs-items v-model="tab" style="background-color: #ffff; min-height: 67vh;box-sizing: border-box;display: flex;flex-direction: column;">
          <v-tab-item :value="'tab-1'" v-if="myCreditTransaction">
             <v-card flat>
                      <v-card-text>
                        <v-data-table
                        class = "mytable"
                        :headers="columns2"
                        :items="myCreditTransaction"
                        :items-per-page="10"
                        dense
                        >
                    <template v-slot:[`item.CREATE_DATE`]="{ item }">
                      {{ format_date(item.CREATE_DATE) }}
                    </template>
                    <template v-slot:[`item.status`]="{ item }">
                        <v-chip :color="item.status === 'increase' ? 'green' : 'red'" dark>
                        {{ item.status === 'increase' ? $t("message.increase") : $t("message.decrease") }}
                        </v-chip>
                    </template>
                    <template v-slot:[`item.credits`]="{ item }">
                        <v-chip :color="item.status === 'increase' ? 'green' : 'red'" dark>
                        {{ (item.status === 'increase' ? '+' : '-') + formatNumber(item.credits)}}
                        </v-chip>
                    </template>
                    <template v-slot:[`item.CREATE_DATE`]="{ item }">
                        {{  $i18n.locale === 'th' ? format_date_thai(item.CREATE_DATE) :  item.CREATE_DATE}}
                    </template>
                  </v-data-table></v-card-text>
                    </v-card>
          </v-tab-item>
        </v-tabs-items>
        </template>
      </div>
      <!-- <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card v-if="dialog && use">
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="closeUseReward">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Use Package</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-list subheader>
            <v-subheader>{{ $t("message.showQrcodeReward") }}</v-subheader>
            <v-divider></v-divider>
          </v-list>
          <v-row>
            <v-col class="text-center">
              <qrcode-usecode
                :shopId="use.shopId"
                :token="use.token"
                :lineUserId="profile.userId"
              ></qrcode-usecode>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row>
            <v-col class="text-center headline1 font20">
              {{ $t("message.detailPackage") }}
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row>
            <v-col class="d-flex flex-column justify-space-between align-center"
              ><v-img :src="use.packageImg" max-width="150"></v-img
            ></v-col>
          </v-row>
          <v-row>
            <v-col class="text-center">
              <v-row class="font16 bold headline1">
                <v-col class="pl-0 pt-2 pb-3">{{ use.name }}</v-col>
              </v-row>
              <v-row class="font14 icon2">
                <v-col class="pl-0 pt-0 pb-3"
                  >{{ $t("message.useBefor") }}
                  <span class="icon1">{{ new Date(use.expirePackage * 1000).toLocaleString() }}</span></v-col
                >
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog> -->
    </div>
  </template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import moment from 'moment'
export default {
  name: 'CredisHistory',
  data () {
    return {
      myPackage: null,
      myCreditTransaction: null,
      member: null,
      profile: null,
      use: null,
      creditData: null,
      tab: null,
      shopId: null,
      dataLineConfig: [],
      columns2: [
        { text: this.$t('message.date'), value: 'CREATE_DATE' },
        { text: this.$t('message.status'), value: 'status' },
        // { text: 'สาขา', value: 'balanceAmount' },
        // { text: 'คะแนนที่ได้', value: 'packagePoint' },
        { text: 'credit', value: 'credits' }
      ]
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    window.scrollTo(0, 0)
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    this.shopId = this.GET_SHOPID()

    await this.getCredit()
    await this.getCreditsTransaction()
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapGetters('shopStore', ['GET_SHOPID']),

    arrayMove (arr, oldindex, newindex) {
      return moment.unix(arr).format('DD/MM/YYYY')
    },
    async getCredit () {
      await axios.get(
        this.DNS_IP +
          `/getCredits?tel=${this.member.tel}&shopId=${this.shopId}`
      ).then(res => {
        this.creditData = res.data[0]
      })
    },
    async getCreditsTransaction () {
      await axios.get(
        this.DNS_IP +
          `/getCredits_Log?memberId=${this.member.memberId}&shopId=${this.shopId}`
      ).then(res => {
        this.myCreditTransaction = res.data
      })
    }
  }
}
</script>
  <style scoped>
  a.v-tab {
    text-decoration: none;
  }
  </style>



// WEBPACK FOOTER //
// src/components/Home/CredisHistory.vue